module.exports = __webpack_public_path__ + "img/14_attach_terminals.15649736.jpg";